module.exports = __webpack_public_path__ + "img/cost_admin.ab003291.png";